import qc from 'qc'

export enum ResourceCategory {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  DRAGON_BONE = 'dragonbone',
  SEQUENCE_FRAME = 'seqframe', // sequence_frame
  PARTICLE = 'particle',
}

export interface ResourceFile {
  name: string
  ext: string
}

export interface LibInfo {
  name: string
  data?: any
}

export interface ResourcePoolItem {
  path?: string
  name: string
  type: ResourceCategory
  last_modified?: number
  files?: string[] // file urls，文件夹类型的资源，有多个文件
  paths?: string[] // 资源路径，不同目录中存在同名资源的路径集合
}

export type resourceToNodeMapModel = Record<string, string[]> | null
